import React, { Component } from 'react';
import AppEvents from './../../pages/App/AppEvents';
import commonUtil from './../../utils/commonUtil';

const MicrosoftGraph = require('@microsoft/microsoft-graph-client');


class Outlook extends Component {

  UNSAFE_componentWillMount() {
    /* eslint-disable */
    if (this.props && this.props.location && this.props.location.hash) {
      this.queryString = this.props.location.hash.match(/\#(?:access_token)\=([\S\s]*?)\&/)[1];
    }
    /* eslint-enable */
  }
  componentDidMount() {
    this.testButton = AppEvents.subscribe(AppEvents.EVENT_REGISTER.OUTLOOK_CONTACTS);
    commonUtil.showApplicationLoader();
  }
  componentWillUnmount() {
    commonUtil.hideApplicationLoader();
    AppEvents.unsubscribe(AppEvents.EVENT_REGISTER.OUTLOOK_CONTACTS);
  }
  formatResponse = (contacts) => {
    const contactsToSend = [];
    contacts.forEach((contact) => {
      const temp = {};
      temp.id = contact.id;
      if (contact.givenName) {
        temp.firstName = contact.givenName;
      }
      if (contact.surname) {
        temp.lastName = contact.surname;
      }
      if (contact.emailAddresses && contact.emailAddresses.length) {
        temp.emailId = contact.emailAddresses[0].address;
      }
      contactsToSend.push(temp);
    });
    return contactsToSend;
  }
  readOutlook = () => {
    this.testButton = AppEvents.subscribe(AppEvents.EVENT_REGISTER.OUTLOOK_CONTACTS);
    // OUTLOOK API FUNCTIONS =======================
    if (this.queryString && this.queryString.length > 0) {
      // Create a Graph client
      const client = MicrosoftGraph.Client.init({
        authProvider: (done) => {
          // Just return the token
          done(null, this.queryString);
        },
      });

      // Get the first 10 contacts in alphabetical order
      // by given name
      client
        .api('/me/contacts')
        .top(100)
        .select('givenName,surname,emailAddresses')
        .orderby('givenName ASC')
        .get((err, res) => {
          if (err) {
            console.log('err', err.message); // console required
          } else {
            this.formatResponse(res.value);
            // this.testButton = AppEvents.subscribe(AppEvents.EVENT_REGISTER.OUTLOOK_CONTACTS);
            // AppEvents.publish(this.testButton, [res]);
            window.opener.postMessage(JSON.stringify({ messageType: AppEvents.EVENT_REGISTER.OUTLOOK_CONTACTS.toString(), data: this.formatResponse(res.value) }), '*'); // commonUtil.getAppBaseURL()
            window.close();
          }
        });
    } else {
      const error = { responseText: 'Could not retrieve access token' };
      console.log('here3', error); // console required
    }
  }

  render() {
    if (typeof window !== 'undefined' && window) {
      this.readOutlook();
      return (
        <div><h1>Espere mientras sus contactos se están cargando ...</h1></div>
      );
    }
    return null;
  }

}

export default Outlook;
